import appLocaleData from 'react-intl/locale-data/tl';
import tlMessages from '../locales/tl-TL';

const TlLang = {
    messages: {
        ...tlMessages
    },
    locale: 'tl-TL',
    data: appLocaleData
};
export default TlLang;